import './index.scss'
import { ReactNode } from 'react'
import React from 'react'
import clsx from 'clsx'

interface ScreenProps {
	children: ReactNode
	className?: string
}

export function Screen({ children, className }: ScreenProps) {
	return (
		<div className="screen-outer">
			<div className={clsx('screen', className)}>{children}</div>
		</div>
	)
}
